import { Badge, IconButton, Tooltip } from '@mui/material';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { useNavigate } from 'react-router-dom';
import { useNotificationUnreadCount } from '@/modules/notifications/hooks/useNotifications';
import { usePermission } from '@/permissions/usePermission';
import { useAuthStore } from '@/store/authStore';
import { useSuperAdminAuthStore } from '@/store/superAdminAuthStore';
import { PERMISSIONS } from '@/permissions/permissionRegistry';

export function NotificationBell() {
  const navigate = useNavigate();
  const { can } = usePermission();
  const isSuperAdmin = useAuthStore((s) => s.isSuperAdmin);
  const isPlatformAuth = useSuperAdminAuthStore((s) => s.isAuthenticated);
  const unreadQuery = useNotificationUnreadCount();

  const isSuper = isSuperAdmin() || Boolean(isPlatformAuth);

  if (!isSuper && !can(PERMISSIONS.notification.read)) {
    return null;
  }

  const resData = (unreadQuery as any)?.data;
  const count = typeof resData === 'number' ? resData : (resData?.unread ?? resData?.count ?? 0);

  const handleClick = () => {
    if (isSuper) {
      navigate('/super-admin/notifications');
    } else {
      navigate('/notifications');
    }
  };

  return (
    <Tooltip title="Notifications">
      <IconButton onClick={handleClick} aria-label="Notifications" sx={{ p: 1 }}>
        <Badge
          badgeContent={count}
          color="error"
          max={99}
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.68rem',
              fontWeight: 700,
              height: 18,
              minWidth: 18,
              padding: '0 4px',
              borderRadius: '9px',
              bgcolor: '#FF5757',
              top: 3,
              right: 3,
            },
          }}
        >
          <NotificationsNoneOutlinedIcon sx={{ fontSize: '1.4rem' }} />
        </Badge>
      </IconButton>
    </Tooltip>
  );

}

